module.exports = __webpack_public_path__ + "static/media/135-zoom out.c5fb82f5.svg";